import { Pipe, PipeTransform, TemplateRef } from '@angular/core';
import { CapturumTemplateDirective } from '@capturum/ui/api';

@Pipe({
  name: 'menuItemTemplate',
  standalone: true,
})
export class MenuItemTemplatePipe implements PipeTransform {
  public transform(value: ReadonlyArray<CapturumTemplateDirective>, name: string): TemplateRef<any> {
    const node = value?.find((item) => {
      return item.name() === name;
    });

    return node ? node.template : null;
  }
}
